import { Labels } from '../../shared-components/global/labels.js';

Labels.set(
    'ui-cookie-consent',
    'mainTitle',
    'Наши файлы cookie, Ваши настройки'
);
Labels.set('ui-cookie-consent', 'settingsTitle', 'Настройки файлов cookie');
Labels.set(
    'ui-cookie-consent',
    'mainInfo',
    'Зарегистрированные в {country} {entitiesLink} группы Swedbank используют {cookiesLink} или подобные технологии, которые необходимы для функционирования данного веб-сайта. Вы также можете выбрать файлы cookie для улучшения и персонализации Вашего использования веб-сайта:'
);
Labels.set(
    'ui-cookie-consent',
    'secondaryInfo',
    'Нажав на кнопку «Управление файлами cookie», Вы можете выбрать, какие файлы cookie Вы примете. Вы можете отозвать своё согласие на использование файлов cookie в любое время на странице «{usageLink}». Для получения дополнительной информации ознакомьтесь с нашей {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'settingsInfo',
    'Вы можете отозвать своё согласие на использование файлов cookie в любое время на странице «{usageLink}». Для получения дополнительной информации ознакомьтесь с нашей {policyLink}.'
);
Labels.set(
    'ui-cookie-consent',
    'thirdPartyDisclaimer',
    'На этом веб-сайте используются сторонние файлы cookie.'
);
Labels.set('ui-cookie-consent', 'accept', 'Принять все файлы cookie');
Labels.set(
    'ui-cookie-consent',
    'decline',
    'Принять только необходимые файлы cookie'
);
Labels.set('ui-cookie-consent', 'myCookies', 'Управление файлами cookie');
Labels.set(
    'ui-cookie-consent',
    'saveChoice',
    'Сохранить настройки файлов cookie'
);
Labels.set('ui-cookie-consent', {
    HELP_NECESSARY:
        'Эти файлы cookie обеспечивают бесперебойную и безопасную работу сайта и не могут быть отключены. Содержат важные функции, такие как вход на сайт и настройки языка.',
    HELP_ANALYTICAL:
        'Помогают нам понять, как используется наш сайт, какие функции популярны, что вызывает сложности. Мы используем эти данные для улучшения нашего сайта. При Вашем отказе статистика не будет собираться.',
    HELP_TARGETING:
        'Помогают предоставлять Вам персонализированную информацию о наших продуктах и услугах. Если Вы откажетесь, персонализированный контент не будет отображаться.',
    HELP_FUNCTIONAL:
        'Эти файлы cookie делают использование более удобным. Без них Вам, возможно, придётся повторно вводить данные, фильтровать контент, больше прокручивать страницу и Вы можете упустить другие полезные функции.',
});

Labels.set('ui-cookie-consent', {
    CATEGORY_NECESSARY: 'Необходимые',
    CATEGORY_TARGETING: 'Для отбора целевой аудитории',
    CATEGORY_ANALYTICAL: 'Аналитические',
    CATEGORY_FUNCTIONAL: 'Функциональные',
});
Labels.set('ui-cookie-consent', {
    COOKIE_TARGETING: 'Для отбора целевой аудитории',
    COOKIE_ANALYTICAL: 'Аналитические',
    COOKIE_FUNCTIONAL: 'Функциональные',
});
Labels.set('ui-cookie-consent', 'EE', 'Эстонии');
Labels.set('ui-cookie-consent', 'LV', 'Латвии');
Labels.set('ui-cookie-consent', 'LT', 'Литве');
Labels.set('ui-cookie-consent', 'entities', 'предприятия');
Labels.set('ui-cookie-consent', 'cookies', 'файлы cookie');
Labels.set('ui-cookie-consent', 'language', 'Язык');
Labels.set('ui-cookie-consent', 'usage', 'Файлы cookie');
Labels.set(
    'ui-cookie-consent',
    'policyLinkLabel',
    'Политикой использования файлов cookie в интернет-ресурсах Swedbank'
);
